import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
import HomePage from './pages/HomePage.vue';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage.vue'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage.vue'

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/terms-and-conditions',
      name: 'terms-and-conditions',
      component: TermsAndConditionsPage
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicyPage
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
